/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState, Fragment } from "react";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { ai, getAppInsights } from "../setup/AppInsightsSetup";
import { useNavigate, useLocation } from "react-router-dom";
import { SeverityLevel } from "@microsoft/applicationinsights-web";

const AppInsightsProvider: React.FC<any> = ({ children, instrumentationKey, after }) => {
  const [initialized, setInitialized] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (
      !initialized &&
      Boolean(instrumentationKey)
    ) {
      // Create a history-like object that AppInsights can use
      const historyLike = {
        listen: () => {
          // Return a dummy unsubscribe function
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          return () => {};
        },
        location: location,
        push: navigate,
        replace: (path: string) => navigate(path, { replace: true }),
      };
      
      ai.initialize(instrumentationKey, historyLike);
      setInitialized(true);
    }
    after();
  }, [initialized, instrumentationKey, navigate, location, after]);

  return <Fragment>{children}</Fragment>;
};

export const trackTrace = (message: string, severity: SeverityLevel) => {
  if (message) {
    const instance = getAppInsights();
    instance.trackTrace({
      message: message,
      severity: severity,
    });
  }
};

export const trackError = (error: Error) => {
  const instance = getAppInsights();
  instance.trackException({
    exception: error,
  });
};

export const trackErrorMessage = (
  errorTitle: string | null | undefined,
  errorMessage: string | null
) => {
  if (errorMessage) {
    const instance = getAppInsights();
    instance.trackException({
      exception: new Error(
        `${errorTitle || "Unhandled exception"}: ${errorMessage}`
      ),
    });
  }
};

export default withAITracking(ai.reactPlugin, AppInsightsProvider);
